import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=ae41e38a"
var script = {}
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=ae41e38a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports